import { LOADING_SKELETON_DELAY_MS } from '@codametrix/ui-components';

/**
 * Delay before skeleton loading slugs appear in code bench and case detail views.
 * Tune this value to balance fast-load responsiveness vs. avoiding loading flashes.
 */
export const BENCH_LOADING_SKELETON_DELAY_MS = LOADING_SKELETON_DELAY_MS;

/** Delay before invoice/charge-panel skeletons appear (longer than general bench slugs). */
export const BENCH_INVOICES_LOADING_DELAY_MS = 300;
